import axios from "axios";
import router from '@/router'
import { Toast } from 'vant'
import NProgress from '@/utils/nprogress'
axios.defaults.baseURL = 'https://www.shanyu.vip'; // 设置默认baseURL
//创建axios的实例
const service = axios.create({
    baseURL: 'https://www.shanyu.vip',   //基础api
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8' // 默认 JSON 格式
    }
})

// 记录正在请求的数量
let loadingCount = 0
let loadingInstance = null
// 请求拦截器
service.interceptors.request.use(config => {
    // 检测 config.data 中是否包含任何 File 对象
    const containsFile = (data) => {
        if (data instanceof FormData) return true;
        if (data instanceof File || data instanceof Blob) return true;
        if (typeof data === 'object' && data !== null) {
            return Object.values(data).some(containsFile);
        }
        return false;
    };
    if (containsFile(config.data)) {
        // 如果包含文件，转换为 FormData（兼容普通字段）
        const formData = new FormData();
        for (const key in config.data) {
            formData.append(key, config.data[key]);
        }
        config.data = formData;
        config.headers['Content-Type'] = 'multipart/form-data';
    }
    NProgress.start() // 开始进度条
    if (config.showLoading !== false) { // 允许单个请求配置是否显示loading
        loadingCount++
        if (loadingCount === 1) {
            loadingInstance = Toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0 // 持续展示
            })
        }
    }
    return config
}, error => {
    NProgress.done() // 结束进度条
    return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(response => {
    NProgress.done() // 结束进度条
    const res = response
    console.log(res);
    
    if (response.config.showLoading !== false) {
        loadingCount--
        if (loadingCount <= 0) {
            loadingInstance && loadingInstance.clear()
            loadingCount = 0
        }
    }
    // 根据你的后端响应结构调整
    if (res.data.code && res.data.code != 200) {
        // 特殊状态码处理
        if ([401].includes(res.data.code)) {
            localStorage.removeItem('auth_token')
            router.push('/login')
        }
        Toast(`${res.data.message}`)
        return Promise.reject(new Error(res.data.message || 'Error'))
    }
    return res
}, error => {
    // 错误时也要关闭loading
    if (error.config?.showLoading !== false) {
        loadingCount = 0
        loadingInstance && loadingInstance.clear()
    }
    return Promise.reject(error)
})







export default service